import React, { useState, useEffect, useMemo, createRef, useCallback } from 'react'
import {FieldUnit, Separator, FieldBox, SelectorTitle} from '../../common/formParts/FieldPartsStyled'
import DeliveryDestinationSelector from './DeliveryDestinationSelector'
import SVG from 'react-inlinesvg';
import Delete from '../../common/formParts/icons/Delete.svg'
import Link from '../../common/formParts/icons/Link.svg'

const DeliveryDestinationOptions = (props) => {
  // console.log("DeliveryDestinationOptions")
  const [delivery_destination, setDeliveryDestination] = useState(props.delivery_destination)
  const [selectorTitle, setSelectorTitle] = useState("")
  const destinationNumber = props.destinationNumber

  useEffect(() => {
    // console.log("update destinations in DeliveryDestinationOptions")
    const newDestinations = props.destinations.map((dest) => {
      if (dest.number === delivery_destination.number) {
        return delivery_destination
      } else {
        return dest
      }
    })

    props.handleUpdateDestinations(newDestinations)
  },[delivery_destination])

  const handleChangeDeliveryDestination = (e) => {
    const updatedDeliveryDestination = {
      name: e.target.value,
      number: delivery_destination.number,
      id: delivery_destination.id,
    }
    setDeliveryDestination(updatedDeliveryDestination)
  }

  const handleRemoveCurrentDestination = (nber) => {
    props.handleRemove(nber)
  }

  // get options data for each type of delivery destination
  const options = useMemo(() => {
    if (delivery_destination.name === "article") {
      setSelectorTitle("物件を選択してください")
      return props.articles
    } else if (delivery_destination.name === "app") {
      setSelectorTitle("アプリを選択してください")
      return props.apps
    } else if (delivery_destination.name === "delivery_group") {
      setSelectorTitle("配信グループを選択してください")
      return props.news_segments
    } else if (delivery_destination.name === "member_dwelling_unit") {
      setSelectorTitle("会員住戸を指定する物件を選択してください")
      return props.articles
    }
  },[delivery_destination])

  return (
    <div className="field-unit delivery_destination" key={"delivery_destination_" + props.destinationNumber}>
      <div className="field-unit__label field-unit--required">
        {/*<label htmlFor="delivery_destination_detail">配信先 {destinationNumber > 0 && destinationNumber+1}※</label>*/}
        <label htmlFor="delivery_destination_detail">{destinationNumber > 0 && '追加した'}配信先</label>
      </div>
      <div className="field-unit__field">
        <div id={"delivery_destination_" + delivery_destination.id}>
          <FieldBox>
            <input type="radio"
                   id={"app_"+delivery_destination.number}
                   value="app"
                   checked={delivery_destination.name === "app"}
                   onChange={handleChangeDeliveryDestination} />
            <label htmlFor={"app_"+delivery_destination.number}>アプリ</label>
            <input type="radio"
                   id={"article_"+delivery_destination.number}
                   value="article"
                   checked={delivery_destination.name === "article"}
                   onChange={handleChangeDeliveryDestination} />
            <label htmlFor={"article_"+delivery_destination.number}>物件</label>
            <input type="radio"
                   id={"delivery_group_"+delivery_destination.number}
                   value="delivery_group"
                   checked={delivery_destination.name === "delivery_group"}
                   onChange={handleChangeDeliveryDestination} />
            <label htmlFor={"delivery_group_"+delivery_destination.number}>配信グループ</label>
            <input type="radio"
                   id={"member_dwelling_unit_"+delivery_destination.number}
                   value="member_dwelling_unit"
                   checked={delivery_destination.name === "member_dwelling_unit"}
                   onChange={handleChangeDeliveryDestination} />
            <label htmlFor={"member_dwelling_unit_"+delivery_destination.number}>会員住戸を選択する</label>
            {
              delivery_destination.number !== 0 &&
              <a className="deteteDestination" href="#" onClick={(e) => {e.preventDefault(); handleRemoveCurrentDestination(delivery_destination.number)}}>
                <SVG src={Delete} className='icon' />
                この配信先を削除
              </a>
            }
          </FieldBox>
          <SelectorTitle>{selectorTitle}</SelectorTitle>
          <DeliveryDestinationSelector {...props} key={"key="+delivery_destination.id} delivery_destination={delivery_destination} options={options} />

          {
            delivery_destination.name === "delivery_group" &&
            <FieldUnit className='newsSegment'>
              <a className="newsSegmentLink" href="/manage/news_segments/new">
                <SVG src={Link} className='icon' />
                <span>配信グループを新しく作成する（ページ移動します）</span>
              </a>
            </FieldUnit>
          }
          { !props.isLastDestination && (
            <Separator></Separator>
          )}
        </div>
      </div>
    </div>
  )
}

export default DeliveryDestinationOptions
